module.exports = __webpack_public_path__ + "img/ai-3.67de178e.jpg";